var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasVideoError)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.cameraMsg))]),_c('vs-button',{attrs:{"icon-pack":"feather","icon":"icon-rotate-cw","color":"rgb(255, 255, 255)","type":"line","size":"small"},on:{"click":_vm.connect}},[_vm._v(_vm._s(_vm.retryText))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }